import { NoData, RenderWhen } from "@components";
import RLCard from "@components/card/RLCard";
import Typography from "@components/typography/Typography";
import IPLink from "@modules/graph-explorer/components/common/links/IPLink";
import type { IP } from "@modules/network/@types/IP";

import styles from "@modules/network/components/header/header.module.scss";

type Props = IP & {
  as?: string;
  org?: string;
};

const ServingIpCard = ({ ip, as, org }: Props) => (
  <RLCard
    className={styles.header_card}
    header={
      <RLCard.Header className={styles.card_title}>
        Serving IP Address
      </RLCard.Header>
    }
    content={
      <RLCard.Content className="p-0 flex align-items-center justify-content-center">
        <div className="flex flex-column align-center">
          <RenderWhen
            condition={Boolean(ip)}
            fallback={
              <Typography variant="h5" data-testid="serving-ip-no-data">
                <NoData />
              </Typography>
            }
          >
            <IPLink className="bold fs-lg" ip={ip} />
          </RenderWhen>
          <RenderWhen condition={Boolean(org && as)}>
            <Typography
              variant="body1"
              className="line-height-base text-center"
            >
              {org} | {as}
            </Typography>
          </RenderWhen>
        </div>
      </RLCard.Content>
    }
  />
);

export default ServingIpCard;
